
		<div class="btn-group" role="group" *ngIf="filter.datePeriodList.length || filter.dateFilterList.length">
			<ng-container *ngFor="let _period of filter.datePeriodList">
				<button
					type="button"
					[class]="period == _period ? 'btn btn-light active' : 'btn btn-light'"
					(click)="_onFilterChange({ period: _period })"
				>
					{{ _period }}
				</button>
			</ng-container>
			
			<ng-container *ngFor="let filter of filter.dateFilterList">
				<button
					type="button"
					[class]="dateFilterType == filter ? 'btn btn-light active' : 'btn btn-light'"
					(click)="_onFilterChange({ filter: filter })"
				>
					{{ filter }}
				</button>
			</ng-container>
		</div>
	